import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { base_url } from "../../data/constants";

export const fetchStores = createAsyncThunk(
  "api/stores",
  async (_, thunkApi) => {
    try {
      const { data } = await axios.get(`${base_url}api/stores`);
      return data;
    } catch (error) {
      return thunkApi.rejectWithValue(error.message);
    }
  }
);
